import { Button } from 'primereact/button';
import React, { useEffect, useState } from 'react';
import FlexComponent from '../../FlexComponent';
import axios from '../../../utils/axios';
import { addToQueue, getQueueItems, getSoftwareUsers, removeQueueItem } from '../../../utils/urls';
import AppModal from '../../../shared/AppModal';
import { MultiSelect } from 'primereact/multiselect';
import { useSelector } from 'react-redux';

function Queue({ toast, formId, userId, queueUsersList, isFromQueuePage = false, fetchQueue }) {
    const [isQueuedForMe, setIsQueuedForMe] = useState(queueUsersList?.some((list) => list.id === userId));
    const isSuperuser = useSelector((state) => state.user.isSuperuser);

    const [usersList, setUsersList] = useState([]);
    const [selectedUserIds, setSelectedUserIds] = useState(queueUsersList?.map((list) => list.id));
    const [initialSelectedUserIds, setInitialSelectedUserIds] = useState(queueUsersList?.map((list) => list.id)); // to detect changes

    // console.log("selectedUserIds", selectedUserIds);
    // console.log("initialSelectedUserIds", initialSelectedUserIds);
    // console.log("usersList", usersList);


    const [showManageDialog, setShowManageDialog] = useState(false);
    const [showRemoveConfirm, setShowRemoveConfirm] = useState(false);

    // console.log("selectedUserIds", selectedUserIds);

    // const fetchCurrentQueue = async () => {
    //     try {
    //         const params = { limit: 100, offset: 0 }; // increase limit if needed
    //         const response = await axios.get(getQueueItems, { params });
    //         const queueData = response.data?.['My Queue'] || [];

    //         // Find all users who have this form_id in their queue
    //         const usersWithThisForm = queueData
    //             .filter(item => item.form_id === formId)
    //             .map(item => item.user_id || item.user?.id); // adjust field name if different

    //         setInitialSelectedUserIds(usersWithThisForm);
    //         setSelectedUserIds(usersWithThisForm);

    //         // For current user
    //         setIsQueuedForMe(usersWithThisForm.includes(userId));
    //     } catch (err) {
    //         console.error('Failed to fetch queue state:', err);
    //     }
    // };

    const loadUsersData = () => {
        axios
            .get(getSoftwareUsers, {
                headers: { 'Content-Type': 'application/json' },
            })
            .then((response) => {
                if (response.status === 200) {
                    const options = response.data?.map((user) => ({
                        label: user.full_name,
                        value: user.id,
                        image: user.image,
                    })) || [];
                    setUsersList(options);
                }
            })
            .catch(() => { });
    };

    useEffect(() => {
        loadUsersData();
        // fetchCurrentQueue();
    }, [userId, isSuperuser]);

    const handleSaveQueue = async () => {
        const toAdd = selectedUserIds.filter(id => !initialSelectedUserIds.includes(id));
        const toRemove = initialSelectedUserIds.filter(id => !selectedUserIds.includes(id));

        try {
            // Remove first
            if (toRemove.length > 0) {
                await axios.post(removeQueueItem, {
                    app_id: formId,
                    user_ids: toRemove,
                }, {
                    headers: { 'Content-Type': 'application/json' },
                });
            }

            // Then add
            if (toAdd.length > 0) {
                await axios.post(addToQueue, {
                    app_id: formId,
                    user_ids: toAdd,
                }, {
                    headers: { 'Content-Type': 'application/json' },
                });
            }

            toast.current.show({
                severity: 'success',
                summary: 'Success',
                detail: 'Queue updated successfully',
                life: 3000,
            });

            // Update local state
            const newSelection = [...selectedUserIds];
            setInitialSelectedUserIds(newSelection);
            setSelectedUserIds(newSelection);
            setIsQueuedForMe(newSelection.includes(userId));
            if (isFromQueuePage && newSelection.length === 0) {
                // setQueueItems(prevItems =>
                //     prevItems.filter(item => item.form_id !== formId)
                // );
                fetchQueue()
            }
        } catch (error) {
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Failed to update queue',
                life: 3000,
            });
        } finally {
            setShowManageDialog(false);
        }
    };

    const onClickManage = () => {
        if (isSuperuser) {
            setShowManageDialog(true);
        } else if (isQueuedForMe) {
            setShowRemoveConfirm(true);
        } else {
            // Regular user - add directly
            axios
                .post(addToQueue, {
                    app_id: formId,
                    user_ids: [userId],
                }, {
                    headers: { 'Content-Type': 'application/json' },
                })
                .then(() => {
                    setIsQueuedForMe(true);
                    toast.current.show({ severity: 'success', summary: 'Added to queue', life: 3000 });
                })
                .catch(() => {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to add', life: 3000 });
                });
        }
    };

    return (
        <div className="applicantDivs" style={{ width: '25%' }}>
            {isSuperuser ? (
                <Button
                    style={{
                        boxShadow: 'none',
                        border: '1px solid grey',
                        minWidth: '160px',
                        marginTop: '.8rem',
                    }}
                    onClick={onClickManage}
                    label="Manage Queue"
                />
            ) : isQueuedForMe ? (
                <Button
                    style={{
                        boxShadow: 'none',
                        border: '1px solid grey',
                        minWidth: '190px',
                        marginTop: '.8rem',
                    }}
                    onClick={onClickManage}
                    label="Remove From Queue"
                />
            ) : (
                <Button
                    style={{
                        boxShadow: 'none',
                        border: '1px solid grey',
                        minWidth: '140px',
                        marginTop: '.8rem',
                    }}
                    onClick={onClickManage}
                    label="Add To Queue"
                />
            )}

            <AppModal
                visible={showManageDialog}
                onHide={() => {
                    setSelectedUserIds([...initialSelectedUserIds]);
                    setShowManageDialog(false);
                }}
                header="Manage Queue"
                panelStyle={{ width: '32rem', maxWidth: '95vw' }}
                zIndex={1300}
                footer={
                    <div style={{ display: 'flex', gap: '0.75rem' }}>
                        <button
                            onClick={() => {
                                setSelectedUserIds([...initialSelectedUserIds]);
                                setShowManageDialog(false);
                            }}
                            style={{ padding: '0.5rem 1.25rem', background: 'transparent', border: '1px solid #3a3a40', borderRadius: '8px', color: '#a0a0ab', cursor: 'pointer', fontSize: '0.875rem' }}
                        >Cancel</button>
                        <button
                            onClick={handleSaveQueue}
                            style={{ padding: '0.5rem 1.25rem', background: '#da474e', border: 'none', borderRadius: '8px', color: '#fff', cursor: 'pointer', fontSize: '0.875rem', fontWeight: 600 }}
                        >Update Queue</button>
                    </div>
                }
            >
                <FlexComponent
                    style={{ marginRight: '1rem', marginTop: '1rem' }}
                    flexDirection="column"
                    alignItems="start"
                >
                    <div style={{ marginBottom: '0.5rem', fontWeight: 'bold' }}>
                        Select users who should have this application in their queue:
                    </div>
                    {usersList.length > 0 ? <div style={{ width: '100%' }}>
                        {/* Chips above */}
                        {selectedUserIds.length > 0 && (
                            <div
                                style={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: '0.5rem',
                                    marginBottom: '0.75rem',
                                    maxHeight: '120px',
                                    overflowY: 'auto',
                                    padding: '0.5rem',
                                    border: '1px solid #ced4da',
                                    borderRadius: '6px',
                                    // maxWidth: "400px"
                                    // background: '#f8f9fa'
                                }}
                            >
                                {selectedUserIds.map((id, index) => {
                                    const user = usersList.find(u => u.value === id);
                                    return user ? (
                                        <div
                                            key={index}
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                // background: '#e9ecef',
                                                padding: '0.35rem 0.6rem',
                                                borderRadius: '16px',
                                                fontSize: '0.9rem',
                                                border: "1px solid white"
                                            }}
                                        >
                                            <span>{user.label}</span>
                                            <Button
                                                icon="pi pi-times"
                                                className="p-button-text p-button-sm p-button-rounded"
                                                style={{ marginLeft: '0.4rem', width: '1.4rem', height: '1.4rem', color: "white" }}
                                                onClick={() => setSelectedUserIds(prev => prev.filter(v => v !== id))}
                                            />
                                        </div>
                                    ) : null;
                                })}
                            </div>
                        )}

                        {/* MultiSelect below */}
                        <MultiSelect
                            value={selectedUserIds}
                            options={usersList}
                            onChange={(e) => setSelectedUserIds(e.value)}
                            placeholder={selectedUserIds.length === 0 ? "Select users" : ""}
                            filter
                            style={{ maxWidth: '400px', width: "auto" }}
                        />
                    </div> : <FlexComponent justifyContent="start">
                        <div style={{ minWidth: "20vw", height: "100%" }} className='loadingAppItem'></div>
                    </FlexComponent>}
                </FlexComponent>
            </AppModal>

            {/* Regular user remove confirmation */}
            <AppModal
                visible={showRemoveConfirm}
                onHide={() => setShowRemoveConfirm(false)}
                header="Confirm Removal"
                panelStyle={{ width: '30rem', maxWidth: '95vw' }}
                zIndex={1300}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem' }}>
                        <i className="pi pi-exclamation-triangle" style={{ fontSize: '1.5rem', color: '#f59e0b', marginTop: '2px', flexShrink: 0 }} />
                        <div style={{ color: '#d1d1d6', lineHeight: 1.5, fontSize: '0.9rem' }}>Are you sure you want to remove this application from your queue?</div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.75rem' }}>
                        <button
                            onClick={() => setShowRemoveConfirm(false)}
                            style={{ padding: '0.5rem 1.25rem', background: 'transparent', border: '1px solid #3a3a40', borderRadius: '8px', color: '#a0a0ab', cursor: 'pointer', fontSize: '0.875rem' }}
                        >Cancel</button>
                        <button
                            onClick={() => {
                                axios
                                    .post(removeQueueItem, {
                                        app_id: formId,
                                        user_ids: [userId],
                                    }, {
                                        headers: { 'Content-Type': 'application/json' },
                                    })
                                    .then(() => {
                                        setIsQueuedForMe(false);
                                        if (isFromQueuePage) {
                                            fetchQueue()
                                        }
                                        toast.current.show({ severity: 'success', summary: 'Removed from queue', life: 3000 });
                                    })
                                    .catch(() => {
                                        toast.current.show({ severity: 'error', summary: 'Error', life: 3000 });
                                    })
                                    .finally(() => setShowRemoveConfirm(false));
                            }}
                            style={{ padding: '0.5rem 1.25rem', background: '#da474e', border: 'none', borderRadius: '8px', color: '#fff', cursor: 'pointer', fontSize: '0.875rem', fontWeight: 600 }}
                        >Yes, Remove</button>
                    </div>
                </div>
            </AppModal>
        </div>
    );
}

export default Queue;